function bgWaitForOneTrust() {
	bgHasOneTrustLoaded();
	let attempts = 0;
	const interval = setInterval(function () {
		if (bgHasOneTrustLoaded() || attempts > 100) {
			clearInterval(interval);
		}
		attempts++;
	}, 100)
}

function bgHasOneTrustLoaded() {
	if (typeof window.OnetrustActiveGroups === 'string') {
		bgOptanonWrapper()
		// and wrap and trigger after cookie opt-in
		window.OptanonWrapper = bgOptanonWrapper;
		return true;
	}
	return false;
}

function bgsendConsent(trackingConsent) {
	console.log(trackingConsent)
	window.Shopify.customerPrivacy.setTrackingConsent(trackingConsent, () => {
		console.log("Shopify Consent Captured")
		//To reload a page once consent is updated by the user
		document.querySelectorAll('.save-preference-btn-handler.onetrust-close-btn-handler, #onetrust-accept-btn-handler, #onetrust-reject-all-handler, #accept-recommended-btn-handler').forEach(el => {
			el.addEventListener('click', function () {
				window.location.reload();
			});
		});
	});
}

function bgConsent(iframe) {
	// Get all elements with the specified class
	var consentElements = document.getElementsByClassName('bg-video-sec');
	// Check if any elements were found
	while (consentElements.length > 0) {
		// Remove the first element with the specified class
		consentElements[0].remove();
	}

	// Get the div elements by their class name
	const consentDivs = document.getElementsByClassName('bg-consent-thumb');
	const autoplayControl = document.getElementById('vimeo-control')
	// Loop through the divs and set their display property to "block"
	for (let i = 0; i < consentDivs.length; i++) {
		consentDivs[i].style.display = 'block';
	}
}

function bgOptanonWrapper() {
	performanceConsent = !!window.OnetrustActiveGroups.includes('C0002');
	functionalConsent = !!window.OnetrustActiveGroups.includes('C0003');
	targetingConsent = !!window.OnetrustActiveGroups.includes('C0004');
	const trackingConsent = { analytics: performanceConsent, marketing: targetingConsent, preferences: functionalConsent, sale_of_data: false };

	window.Shopify.loadFeatures(
		[
			{
				name: 'consent-tracking-api',
				version: '0.1',
			},
		],
		error => {
			if (error) {
				throw error;
			}
			bgsendConsent(trackingConsent)
		},
	);
	if (!window.OnetrustActiveGroups.includes('C0001') || !window.OnetrustActiveGroups.includes('C0002') || !window.OnetrustActiveGroups.includes('C0003') || !window.OnetrustActiveGroups.includes('C0004')) {
		if (document.getElementsByClassName('bg-video-sec').length > 0) {
			let iframes = document.getElementsByClassName('bg-video-sec');
			let abc = document.getElementsByTagName("iframe")
			for (var i = 0; i < iframes.length; i++) {
				iframes[i].style.display = "none";
				bgConsent(iframes[i]);
			}
		}


		if (document.getElementsByClassName('scroll-btn').length > 0) {
			let scrollBtn = document.getElementsByClassName('scroll-btn')
			for (var i = 0; i < scrollBtn.length; i++) {
				scrollBtn[i].style.display = "none";
			}
		}

		if (document.getElementsByClassName('bg-consent-thumb').length > 0) {
			const consentDivs = document.getElementsByClassName('bg-consent-thumb');
			// Loop through the divs and set their display property to "block"
			for (let i = 0; i < consentDivs.length; i++) {
				consentDivs[i].style.display = 'block';
			}
		}

		if (document.getElementsByClassName('bg-modal').length > 0) {
			let bgmodalsec = document.getElementsByClassName('bg-modal');
			for (var i = 0; i < bgmodalsec.length; i++) {
				bgmodalsec[i].style.display = "none";
			}
		}
	}
}

(function () {
	// Loop through the divs and set their display property to "none"
	// Get the div elements by their class name
	const consentDiv = document.getElementsByClassName('bg-consent-thumb');
	for (let i = 0; i < consentDiv.length; i++) {
		consentDiv[i].style.display = 'none';
	}
	bgWaitForOneTrust();
})();